import { ApplicationRef, createComponent } from '@angular/core';
import { Auth0CallbackErrorComponent } from './auth0-callback-error.component';
import type { CallbackErrorAwareAuthService } from './callback-error-aware-auth.service';

/**
 * Bug 37976: after bootstrap, put the refused-login panel over the app when a callback error is held, so the user
 * sees why and can try again or sign out instead of a spinner. Adds nothing on a normal load.
 */
export function mountAuth0CallbackError(
  appRef: ApplicationRef,
  auth: CallbackErrorAwareAuthService
): void {
  if (!auth.callbackError() || typeof document === 'undefined') return;
  const ref = createComponent(Auth0CallbackErrorComponent, {
    environmentInjector: appRef.injector,
  });
  ref.setInput('auth', auth);
  appRef.attachView(ref.hostView);
  ref.changeDetectorRef.detectChanges();
  document.body.appendChild(ref.location.nativeElement);
}
